/**
 * Created by sy on 2018/12/6.
 */
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

import sub_index from "views/sub/sub_index";
import sub_alfx from "views/sub/sub_alfx";
import sub_homework from "views/sub/sub_homework";
import sub_report from "views/sub/sub_report";
import sub_do from "views/sub/sub_do";
import sub_reflect from "views/sub/sub_reflect";
import sub_alfx_detail from "views/sub/sub_alfx_detail";
import sub_alfx_detail_yl from "views/sub/sub_alfx_detail_yl";
import sub_homework_detail from "views/sub/sub_homework_detail";
import sub_reflect_detail from "views/sub/sub_reflect_detail";
import sub_do_detail from "views/sub/sub_do_detail";

export default [
  {
    path: "/main/sub_index",
    redirect: "/main/sub_index/sub_report",
    keepAlive: true,
  },
  {
    path: "/main/sub_index",
    name: "sub_index",
    component: sub_index,
    meta: { keepAlive: true },
    children: [
      {
        path: "sub_report",
        name: "下属报表",
        component: sub_report,
        meta: {
          title: "下属报表",
          title_en: "Subordinate Report",
          keepAlive: true,
        },
      },
      {
        path: "sub_homework",
        name: "下属作业",
        component: sub_homework,
        meta: {
          title: "下属作业",
          title_en: "Subordinate Assignment",
          keepAlive: true,
        },
      },
      {
        path: "sub_alfx",
        name: "下属案例分析",
        component: sub_alfx,
        meta: {
          title: "下属案例分析",
          title_en: "Subordinate Case",
          keepAlive: true,
        },
      },
      {
        path: "sub_reflect",
        name: "下属反思",
        component: sub_reflect,
        meta: {
          title: "下属反思",
          title_en: "Subordinate Reflection",
          keepAlive: true,
        },
      },
      {
        path: "sub_do",
        name: "下属实践",
        component: sub_do,
        meta: {
          title: "下属实践",
          title_en: "Subordinate Drill",
          keepAlive: true,
        },
      },
    ],
  },
  {
    path: "/main/sub_alfx_detail",
    name: "sub_alfx_detail",
    component: sub_alfx_detail,
    meta: { title: "", title_en: "" },
  },
  {
    path: "/main/sub_alfx_detail_yl",
    name: "sub_alfx_detail_yl",
    component: sub_alfx_detail_yl,
    meta: { title: "", title_en: "" },
  },
  {
    path: "/main/sub_homework_detail",
    name: "sub_homework_detail",
    component: sub_homework_detail,
    meta: { title: "", title_en: "" },
  },
  {
    path: "/main/sub_reflect_detail",
    name: "sub_reflect_detail",
    component: sub_reflect_detail,
    meta: { title: "个人反思报表", title_en: "Self-reflection Report" },
  },
  {
    path: "/main/sub_do_detail",
    name: "sub_do_detail",
    component: sub_do_detail,
    meta: { title: "实践工具报表", title_en: "Practice tool report" },
  },
];
